import {
  LOGIN,
  LOGOUT,
  INIT_LOGIN,
  LOGIN_GET_VERIFICATION,
  PENDING,
  FULFILLED,
  REJECTED,
} from "./constants.js"

const defaultState = {
  loginState: false,
  token: "",
  loginCounter: 0,
  loginShowCountDown: false,
  loginLoading: false,
  loginErrMessage: "",
  loginHaveVerification: false,
}

function reducer(state = defaultState, action) {
  switch (action.type) {
    case INIT_LOGIN:
      return {
        ...state,
        loginState: true,
        token: action.payload,
      }
    case LOGIN_GET_VERIFICATION + PENDING:
      return { ...state, loginLoading: true }
    case LOGIN_GET_VERIFICATION + FULFILLED:
      return { ...state, loginLoading: false }
    case LOGIN_GET_VERIFICATION:
      return { ...state, loginLoading: false }
    case LOGIN + PENDING:
      return { ...state, loginLoading: true }
    case LOGIN + FULFILLED:
      return {
        ...state,
        loginState: true,
        token: action.payload,
        loginLoading: false,
      }
    case LOGIN + REJECTED:
      return {
        ...state,
        loginErrMessage: action.payload,
        loginLoading: false,
      }
    case LOGOUT:
      return { ...state, loginState: false, token: "" }
    default:
      return state
  }
}

export default reducer
